import { login, forgotPass, resetPass } from "../api/userApi";

export const loginUser = async (cuit, password) => {
  try {
    const response = await login({ cuit, password });
    const user = response.data;

    localStorage.setItem("user", JSON.stringify(user));
    return user;
  } catch (error) {
    throw new Error("Credenciales inválidas");
  }
};

export const resetPassword = async (token, newPassword) => {
  try {
    const response = await resetPass({ token, newPassword });
    const user = response.data;

    return user;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error al restablecer la contraseña");
  }
};


export const forgotPassword = async (cuit, mail) => {
  try {
    const response = await forgotPass({ cuit, mail });
    const user = response.data;

    return user;
  } catch (error) {
    throw new Error("Credenciales inválidas");
  }
};

export const getCurrentUser = () => {
  const data = localStorage.getItem("user");
  return data ? JSON.parse(data) : null;
};

export const logoutUser = () => {
  localStorage.removeItem("user");
};